import { Link } from "react-router-dom";

const DIRECTIONS = [
  {
    slug: "klink",
    name: "Klink",
    tagline: "Bright, optimistic, mass-market consumer.",
    bg: "#FFFDF9", fg: "#2B2826", accent: "#FF8A66", bonus: "#FFD166",
    font: { display: "'Outfit', sans-serif", body: "'Figtree', sans-serif" },
    chips: ["Light · soft", "Pastel coral + butter yellow", "Outfit · Figtree", "Rounded pills, soft shadows"],
  },
  {
    slug: "mynte",
    name: "Mynte",
    tagline: "Premium, considered, slightly editorial.",
    bg: "#F4F4F0", fg: "#1E2019", accent: "#A88E6D", bonus: "#394A3E",
    font: { display: "'Cormorant Garamond', serif", body: "'IBM Plex Sans', sans-serif" },
    chips: ["Editorial · Swiss", "Bone + brass + forest", "Cormorant + Plex", "1px borders, no shadows"],
  },
  {
    slug: "pling",
    name: "Pling",
    tagline: "Bold, playful, energetic — habit-tracker for your money.",
    bg: "#0F0F0F", fg: "#FFFFFF", accent: "#E0FF00", bonus: "#FF0055",
    font: { display: "'Clash Display', sans-serif", body: "'JetBrains Mono', monospace" },
    chips: ["Neo-brutalist · dark", "Volt yellow + hot pink", "Clash Display + Mono", "Hard shadows, ALL CAPS"],
  },
  {
    slug: "loftet",
    name: "Loftet",
    tagline: "For SAS-bonus-jegere. Premium, aviation-inspired, data-driven.",
    bg: "#0A1628", fg: "#F5EFE0", accent: "#D4A957", bonus: "#E5C77F",
    font: { display: "'Fraunces', serif", body: "'IBM Plex Sans', sans-serif" },
    chips: ["Aviation · premium", "Navy + champagne", "Fraunces + Plex", "Boarding-pass aesthetic"],
  },
  {
    slug: "sirius",
    name: "Sirius",
    tagline: "Daytime sky. Weekend-traveler optimism for the casual SAS flyer.",
    bg: "#F0F6FB", fg: "#0B2440", accent: "#FF8A5C", bonus: "#6FB6F2",
    font: { display: "'Fraunces', serif", body: "'IBM Plex Sans', sans-serif" },
    chips: ["Daylight · airy", "Sky blue + sunrise", "Fraunces + Plex", "Optimistic, soft glow"],
  },
  {
    slug: "krans",
    name: "Krans",
    tagline: "Ultra-premium black card. For Diamond-tier point hoarders.",
    bg: "#08080A", fg: "#F2EDE2", accent: "#B89968", bonus: "#D4B380",
    font: { display: "'Fraunces', serif", body: "'IBM Plex Sans', sans-serif" },
    chips: ["Centurion · invitation", "Carbon + brass", "Fraunces + Plex Mono", "Hairline borders, no fluff"],
  },
  {
    slug: "kompass",
    name: "Kompass",
    tagline: "Vintage flight chart. Cream paper, oxblood ink, navigator's tool.",
    bg: "#F5EFE0", fg: "#1A1A18", accent: "#8C2E1F", bonus: "#2D4032",
    font: { display: "'Fraunces', serif", body: "'IBM Plex Sans', sans-serif" },
    chips: ["Cartographic · craft", "Aged paper + oxblood", "Fraunces + Plex Mono", "Isobars, compass rose"],
  },
];

export default function MockupGallery() {
  return (
    <div style={{ background: "#0A0A0A", color: "#fff", minHeight: "100vh", fontFamily: "'IBM Plex Sans', system-ui, sans-serif" }}>
      <div style={{ maxWidth: 1280, margin: "0 auto", padding: "80px 32px 120px" }}>
        <Link to="/" style={{ display: "inline-block", fontSize: 11, letterSpacing: "0.25em", color: "#A1A1AA", textDecoration: "none", marginBottom: 48 }}>
          ← BACK TO ADMIN
        </Link>

        <div style={{ fontSize: 10, letterSpacing: "0.3em", color: "#52525B", fontWeight: 700, marginBottom: 18 }}>
          // CONSUMER MOCKUPS · 7 DIRECTIONS
        </div>
        <h1 style={{ fontFamily: "'Clash Display', sans-serif", fontSize: "clamp(48px, 7vw, 88px)", fontWeight: 600, letterSpacing: "-0.04em", lineHeight: 0.95, margin: 0, marginBottom: 24 }}>
          Pick a direction.<br />
          <span style={{ color: "#52525B" }}>Seven takes on the same product.</span>
        </h1>
        <p style={{ maxWidth: 640, fontSize: 16, lineHeight: 1.6, color: "#A1A1AA", margin: 0, marginBottom: 64 }}>
          Same data, same flows, same payment-method detection and bonus-program tracking — seven completely different visual personalities for the consumer-facing app at 15 kr/mnd. Click into each to see landing + extension popup + dashboard side-by-side.
        </p>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: 24 }}>
          {DIRECTIONS.map((d) => (
            <Link
              key={d.slug}
              to={`/mockups/${d.slug}`}
              data-testid={`mockup-card-${d.slug}`}
              style={{
                textDecoration: "none", color: "inherit", display: "block",
                background: d.bg, borderRadius: 16, overflow: "hidden",
                border: "1px solid rgba(255,255,255,0.08)", padding: 28,
                transition: "transform .2s ease, box-shadow .2s ease",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = `0 20px 40px ${d.accent}33`; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 32 }}>
                <span style={{ width: 12, height: 12, borderRadius: d.slug === "pling" ? 0 : "50%", background: d.accent }} />
                <span style={{ fontSize: 10, letterSpacing: "0.25em", color: d.fg, opacity: 0.7, fontWeight: 700 }}>DIRECTION 0{DIRECTIONS.indexOf(d) + 1}</span>
              </div>
              <h2 style={{ fontFamily: d.font.display, fontSize: 56, fontWeight: d.slug === "mynte" ? 400 : 700, lineHeight: 1, margin: 0, color: d.fg, letterSpacing: d.slug === "pling" ? "-0.04em" : "-0.02em" }}>
                {d.name}{d.slug === "klink" ? "." : ""}
              </h2>
              <p style={{ fontFamily: d.font.body, fontSize: 15, lineHeight: 1.5, color: d.fg, opacity: 0.7, margin: "16px 0 28px" }}>{d.tagline}</p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {d.chips.map((c) => (
                  <span key={c} style={{
                    fontSize: 11, padding: "4px 10px", borderRadius: d.slug === "klink" ? 999 : 4,
                    background: d.slug === "pling" ? d.accent : `${d.accent}1f`,
                    color: d.slug === "pling" ? "#000" : d.fg,
                    fontFamily: d.font.body, fontWeight: 600,
                  }}>{c}</span>
                ))}
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 32, paddingTop: 20, borderTop: `1px solid ${d.fg}1a` }}>
                <span style={{ fontSize: 11, letterSpacing: "0.2em", color: d.fg, opacity: 0.6, fontWeight: 700 }}>LANDING · POPUP · DASHBOARD</span>
                <span style={{ fontSize: 18, color: d.accent }}>→</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
